import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const spinner = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const ResendContainer = styled.div`
  color: #2164db;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: end;
`
export const ResendText = styled.p<{ isClickActive: boolean }>`
  cursor: ${({ isClickActive }) => (isClickActive ? 'pointer' : 'default')};
`

export const InfoIcon = styled(FontAwesomeIcon)<{ showAnimation: boolean }>`
  bottom: 0;
  height: 12px;
  margin: 0 6px;
  right: 0;
  width: 12px;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: ${({ showAnimation }) => (showAnimation ? spinner : null)};
`
